import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ChevronRight } from 'lucide-react';
import { Progress } from '../ui/progress';
import { cn } from '../../lib/utils';

const TrackCard = ({ track, className }) => {
  const navigate = useNavigate();
  const { id, title, titlePt, description, icon, totalLessons, completedLessons, locked } = track;
  const progress = (completedLessons / totalLessons) * 100;

  const handleClick = () => {
    if (!locked) {
      navigate(`/track/${id}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={locked}
      data-testid={`track-card-${id}`}
      className={cn(
        'track-card w-full text-left',
        locked && 'opacity-60 cursor-not-allowed',
        className
      )}
    >
      {/* Icon and Lock indicator */}
      <div className="flex items-start justify-between mb-3">
        <span className="text-3xl">{icon}</span>
        {locked ? (
          <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center">
            <Lock className="w-4 h-4 text-muted-foreground" />
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
            <ChevronRight className="w-4 h-4 text-primary" />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="space-y-1 mb-4">
        <h3 className="font-display font-semibold text-lg">{title}</h3>
        <p className="text-sm text-muted-foreground">{titlePt}</p>
        <p className="text-xs text-muted-foreground line-clamp-2">{description}</p>
      </div>

      {/* Progress */}
      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Progresso</span>
          <span className="font-medium">{completedLessons}/{totalLessons} lições</span>
        </div>
        <Progress value={progress} className="h-1.5" />
      </div>

      {locked && (
        <p className="text-xs text-muted-foreground mt-3 flex items-center gap-1">
          <Lock className="w-3 h-3" />
          Complete Daily Life para desbloquear
        </p>
      )}
    </button>
  );
};

export default TrackCard;
